<template>
    <component :is="component" v-bind="forwardedProps" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';

    import support from '@/config/support';

    import DesktopFileUploadInput from './FileUploadInput/DesktopFileUploadInput.vue';
    import MobileFileUploadInput from './FileUploadInput/MobileFileUploadInput.vue';

    // PRODUCT-26110 Task 12 (COMPONENT_V_MODEL): migrated to the Vue 3 v-model
    // contract. Consumed via v-model by fields/File.vue. This is a pure dispatch
    // wrapper -- it never emits itself, it spreads `modelValue` (via `$props`) and
    // whatever `onUpdate:modelValue` listener it received (via `$attrs`) straight
    // down to whichever of Desktop/MobileFileUploadInput is rendered.
    @Component({})
    export default class FileUploadInput extends Vue {
        @Prop({ type: String, default: undefined })
        private id!: string | undefined;

        @Prop({ type: Array, default: () => [] })
        private modelValue!: File[];

        @Prop({ type: Boolean, default: false })
        private submitting!: boolean;

        @Prop({ type: Boolean, default: false })
        private imagesOnly!: boolean;

        @Prop({ type: String, default: '' })
        private description!: string;

        @Prop({ type: Boolean, default: support.isMobileBrowser })
        private isMobile!: boolean;

        private get component() {
            return this.isMobile ? MobileFileUploadInput : DesktopFileUploadInput;
        }

        // PRODUCT-26110 Task 10 (INSTANCE_LISTENERS): Vue's template compiler rejects
        // two bare `v-bind` directives on the same element ("Duplicate attribute"), so
        // `v-bind="$props"` and the former `v-on="$listeners"` (now `$attrs`, which
        // carries listeners as `onXxx` keys) must be merged into a single object.
        private get forwardedProps(): Record<string, unknown> {
            return { ...this.$props, ...this.$attrs };
        }
    }
</script>
